import React from 'react';
import { Dashboard } from '../components';

const DashboardPage = ({ apiStatus, user, setCurrentView }) => {
  return (
    <div className="space-y-6">
      {/* Header da Página */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Dashboard</h1>
            <p className="text-gray-600">
              Visão geral do sistema e status das APIs
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
              {user?.role || 'user'}
            </span>
          </div>
        </div>
      </div>
      
      {/* Conteúdo da Página */}
      <Dashboard 
        apiStatus={apiStatus} 
        user={user} 
        setCurrentView={setCurrentView} 
      />
    </div>
  );
};

export default DashboardPage;
